import {
  formatStyleTagsForDisplay,
  normalizeStyleTagList,
} from './styleTags';

export const buildProfilePreferredStyles = (source = {}) => {
  if (Array.isArray(source)) {
    return normalizeStyleTagList(source, { splitCommas: true });
  }

  if (typeof source === 'string') {
    return normalizeStyleTagList(source, { splitCommas: true });
  }

  const profile = source && typeof source === 'object' ? source : {};
  const preferredStyles = normalizeStyleTagList(
    Array.isArray(profile.preferredStyles) ? profile.preferredStyles : [],
    { splitCommas: true },
  );
  return Array.isArray(profile.preferredStyles)
    ? preferredStyles
    : normalizeStyleTagList(profile.preferredStyle, { splitCommas: true });
};

export const formatProfilePreferredStyles = (source = {}, separator = ', ') => (
  formatStyleTagsForDisplay(buildProfilePreferredStyles(source), separator)
);

export const profilePreferredStylesPayload = (styles) => (
  buildProfilePreferredStyles(styles)
);
